import { render, staticRenderFns } from "./RewardsHistory.vue?vue&type=template&id=2b710df8&"
import script from "./RewardsHistory.vue?vue&type=script&lang=js&"
export * from "./RewardsHistory.vue?vue&type=script&lang=js&"
import style0 from "./RewardsHistory.vue?vue&type=style&index=0&id=2b710df8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports